function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.function.bind.js";
import React, { useContext } from 'react';
import { Box, Breadcrumbs } from '@applyboard/ui-components';
import { useEventTracker, UserContext } from '@applyboard/ui-utils';
import { applicationCurrentApplicationSelector, Link, PageWrapper } from '@applyboard/ab-common';
import Application from "./Application";
import InitialPropsContext from "../../components/InitialPropsContext";
import SurveyWrapper from "../../components/SurveyWrapper";
import AddRequirementModal from "../../components/AddRequirementModal";
import getApplicationBreadcrumbs from "./getApplicationBreadcrumbs";
import { PageSettingsProvider } from "./PageSettings";
import DuplicatesWarning from "./DuplicatesWarning";
import MultipleNotesModal from "../../components/Modals/MultipleNotes";
import { ApplicationStepper as ApplicationStepperWrapper } from "../../components/ApplicationStepper";
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { getApplicationStatusMessage } from "../../util/common";
import { ActionsMenuWrapper } from "./ActionMenuWrapper";
import { useCreateNotes } from "../../data/notes";
import { useParams } from 'react-router-dom';
var StudentApplication = function StudentApplication(_ref) {
  var _initialProps$permiss, _initialProps$applica, _initialProps$permiss2, _initialProps$applica2, _initialProps$permiss3;
  var initialProps = _ref.initialProps,
    match = _ref.match,
    appName = _ref.appName,
    sidebar = _ref.sidebar,
    applicationStepper = _ref.applicationStepper,
    RemoveFileDialog = _ref.RemoveFileDialog,
    DocumentVerificationModal = _ref.DocumentVerificationModal,
    LegacyApplicationStepper = _ref.LegacyApplicationStepper,
    VerificationResults = _ref.VerificationResults,
    onSidebarOpenChange = _ref.onSidebarOpenChange,
    reloadAggregatedData = _ref.reloadAggregatedData,
    aggregatedDataRequirements = _ref.aggregatedDataRequirements,
    RPSelfEvaluation = _ref.RPSelfEvaluation,
    RecommendedProgramsDialogLoader = _ref.RecommendedProgramsDialogLoader,
    HybridRequirementDecisionReasons = _ref.HybridRequirementDecisionReasons,
    HybridRequirementDialogButton = _ref.HybridRequirementDialogButton,
    HybridRequirementPreviewMode = _ref.HybridRequirementPreviewMode,
    ActionsMenu = _ref.ActionsMenu,
    isRequirementEvaluationPending = _ref.isRequirementEvaluationPending,
    ApplicantRequirementList = _ref.ApplicantRequirementList,
    AdminRequirementList = _ref.AdminRequirementList,
    renderNotesList = _ref.renderNotesList,
    NewViewNotice = _ref.NewViewNotice,
    _ref$hideApplicationR = _ref.hideApplicationRequirementsHeader,
    hideApplicationRequirementsHeader = _ref$hideApplicationR === void 0 ? false : _ref$hideApplicationR,
    _ref$hideAdminRequire = _ref.hideAdminRequirementsHeader,
    hideAdminRequirementsHeader = _ref$hideAdminRequire === void 0 ? false : _ref$hideAdminRequire,
    header = _ref.header,
    canCreateBulkNote = _ref.canCreateBulkNote,
    isMarkdownRendererEnabled = _ref.isMarkdownRendererEnabled,
    commissionTab = _ref.commissionTab;
  var applicationId = Number(match && match.params && match.params.application_id);
  var isAdmin = appName === 'admin';
  var currentUser = useContext(UserContext);
  return /*#__PURE__*/React.createElement(PageSettingsProvider, {
    appName: appName
  }, /*#__PURE__*/React.createElement(PageWrapper, null, header && /*#__PURE__*/React.createElement(Box, {
    mb: 4
  }, header), /*#__PURE__*/React.createElement("div", {
    className: "container-fluid"
  }, /*#__PURE__*/React.createElement(InitialPropsContext.Provider, {
    value: initialProps
  }, /*#__PURE__*/React.createElement("div", {
    className: "card"
  }, !header && /*#__PURE__*/React.createElement("div", {
    className: "card-header"
  }, /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between"
  }, /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement("h3", null, "Show Application"), /*#__PURE__*/React.createElement(ApplicationBreadcrumbs, {
    initialProps: initialProps,
    currentUser: currentUser
  })), /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    alignItems: "flex-end",
    ml: 2
  }, (initialProps === null || initialProps === void 0 ? void 0 : (_initialProps$permiss = initialProps.permissions) === null || _initialProps$permiss === void 0 ? void 0 : _initialProps$permiss.self_serve_view_actions_dropdown) && /*#__PURE__*/React.createElement(Box, {
    flexShrink: 0,
    ml: 1
  }, /*#__PURE__*/React.createElement(ActionsMenuWrapper, {
    applicationId: applicationId,
    ActionsMenu: ActionsMenu,
    isMarkdownRendererEnabled: isMarkdownRendererEnabled
  })))), applicationId && (initialProps === null || initialProps === void 0 ? void 0 : (_initialProps$applica = initialProps.application) === null || _initialProps$applica === void 0 ? void 0 : _initialProps$applica.user_id) && (initialProps === null || initialProps === void 0 ? void 0 : (_initialProps$permiss2 = initialProps.permissions) === null || _initialProps$permiss2 === void 0 ? void 0 : _initialProps$permiss2.view_duplicate_applications) && /*#__PURE__*/React.createElement(DuplicatesWarning, {
    applicationId: applicationId,
    applicantId: initialProps === null || initialProps === void 0 ? void 0 : (_initialProps$applica2 = initialProps.application) === null || _initialProps$applica2 === void 0 ? void 0 : _initialProps$applica2.user_id
  })), /*#__PURE__*/React.createElement("div", {
    className: "card-body"
  }, NewViewNotice && /*#__PURE__*/React.createElement(NewViewNotice, {
    isAdmin: isAdmin
  }), (initialProps === null || initialProps === void 0 ? void 0 : (_initialProps$permiss3 = initialProps.permissions) === null || _initialProps$permiss3 === void 0 ? void 0 : _initialProps$permiss3.view_application_tracking_data) && /*#__PURE__*/React.createElement(ApplicationStepperWrapper, {
    ApplicationStepperComponent: LegacyApplicationStepper
  }), /*#__PURE__*/React.createElement(Application, _extends({
    applicationId: applicationId
  }, initialProps, {
    isAdmin: isAdmin,
    sidebar: sidebar,
    applicationStepper: applicationStepper,
    reloadAggregatedData: reloadAggregatedData,
    RemoveFileDialog: RemoveFileDialog,
    DocumentVerificationModal: DocumentVerificationModal,
    VerificationResults: VerificationResults,
    onSidebarOpenChange: onSidebarOpenChange,
    RPSelfEvaluation: RPSelfEvaluation,
    aggregatedDataRequirements: aggregatedDataRequirements,
    RecommendedProgramsDialogLoader: RecommendedProgramsDialogLoader,
    HybridRequirementDialogButton: HybridRequirementDialogButton,
    HybridRequirementPreviewMode: HybridRequirementPreviewMode,
    HybridRequirementDecisionReasons: HybridRequirementDecisionReasons,
    isRequirementEvaluationPending: isRequirementEvaluationPending,
    ApplicantRequirementList: ApplicantRequirementList,
    AdminRequirementList: AdminRequirementList,
    renderNotesList: renderNotesList,
    hideApplicationRequirementsHeader: hideApplicationRequirementsHeader,
    hideAdminRequirementsHeader: hideAdminRequirementsHeader,
    canCreateBulkNote: canCreateBulkNote,
    isMarkdownRendererEnabled: isMarkdownRendererEnabled,
    commissionTab: commissionTab
  })), /*#__PURE__*/React.createElement(LegacyMultipleNotesModal, {
    isMarkdownRendererEnabled: isMarkdownRendererEnabled
  }), /*#__PURE__*/React.createElement(SurveyWrapper, null), /*#__PURE__*/React.createElement(AddRequirementModal, {
    reloadAggregatedData: reloadAggregatedData
  })))))));
};
export function LegacyMultipleNotesModal(_ref2) {
  var isMarkdownRendererEnabled = _ref2.isMarkdownRendererEnabled,
    noteType = _ref2.noteType;
  var params = useParams();
  var applicationId = Number(params.application_id);
  var _useCreateNotes = useCreateNotes(applicationId),
    createNotes = _useCreateNotes.createNotes;
  return /*#__PURE__*/React.createElement(MultipleNotesModal, {
    createNotes: createNotes,
    isMarkdownRendererEnabled: isMarkdownRendererEnabled,
    noteType: noteType
  });
}
var ApplicationBreadcrumbs = connect(createStructuredSelector({
  application: applicationCurrentApplicationSelector
})
// eslint-disable-next-line @typescript-eslint/no-explicit-any
)(function (props) {
  var _props$initialProps$a;
  // eslint-disable-line @typescript-eslint/no-explicit-any
  var _useEventTracker = useEventTracker({
      data: {
        applicationStatus: getApplicationStatusMessage(props.application),
        applicationStage: (_props$initialProps$a = props.initialProps.application) === null || _props$initialProps$a === void 0 ? void 0 : _props$initialProps$a.current_stage
      }
    }),
    trackEvent = _useEventTracker.trackEvent;
  return /*#__PURE__*/React.createElement(Breadcrumbs, {
    crumbs: getApplicationBreadcrumbs({
      initialProps: props.initialProps,
      currentUser: props.currentUser,
      trackEvent: trackEvent
    }),
    linkComponent: Link
  });
});
export default StudentApplication;